<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="6">
        <v-card
          flat
          class="mb-6"
          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
          <v-card-text>
            <ValidationProvider 
              name="Nomor Surat" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Nomor Surat
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. SRT/PRK/20240102/0001"
                hide-details

                v-model="form.number"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Nomor Surat {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.number !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider 
              name="Tujuan Penerima" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Tujuan Penerima
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. John Doe"
                hide-details

                v-model="form.for"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-3"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Tujuan Penerima {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.for !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <ValidationProvider 
          name="Nama File" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama File
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Surat Menyurat"
            hide-details

            v-model="form.title"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama File {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.title !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Nomor" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nomor
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. 005/PT.UMB/IV/2022"
            hide-details

            v-model="form.template_meta_json_object.nomor"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 70%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nomor {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nomor !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Lampiran" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Lampiran
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. 1 Lembar"
            hide-details

            v-model="form.template_meta_json_object.lampiran"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 50%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Lampiran {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.lampiran !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Hal" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Hal
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Undangan Pengajian dan Buka Bersama Keluarga Besar PT. UMB"
            hide-details

            v-model="form.template_meta_json_object.hal"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 70%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Hal {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.hal !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>



      <ValidationProvider 
        name="Nama Yang Bertandatangan" 
        rules="required" 
        v-slot="{ errors, valid }">
        <div class="body-2 mb-2">
          <span class="red--text">*</span>
          Nama Yang Bertandatangan
          <span class="error--text">
            (wajib diisi)
          </span>
        </div>
        
        <v-text-field
          filled
          rounded
          dense
          :color="set_color"
          
          placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
          hide-details

          v-model="form.template_meta_json_object.nama_1"
          :success="valid"
          :error-messages="errors"
          required
          class="mb-6"
          style="border-radius: 10px;">
          <template v-slot:append-outer>
            <div v-if="errors.length > 0">
              <v-tooltip top color="#ff5252">
                <template v-slot:activator="{ on }">
                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                </template>
                
                Nama Yang Bertandatangan {{ errors[0] }}
              </v-tooltip>
            </div>

            <div v-if="form.template_meta_json_object.nama_1 !== '' && valid">
              <v-icon color="success">mdi-check-circle-outline</v-icon>
            </div>
          </template>
        </v-text-field>
      </ValidationProvider>

      <ValidationProvider 
        name="Jabatan Yang Bertandatangan" 
        rules="required" 
        v-slot="{ errors, valid }">
        <div class="body-2 mb-2">
          <span class="red--text">*</span>
          Jabatan Yang Bertandatangan
          <span class="error--text">
            (wajib diisi)
          </span>
        </div>
        
        <v-text-field
          filled
          rounded
          dense
          :color="set_color"
          
          placeholder="Contoh. Direktur Utama PT.UMB."
          hide-details

          v-model="form.template_meta_json_object.jabatan_1"
          :success="valid"
          :error-messages="errors"
          required
          class="mb-3"
          style="border-radius: 10px;">
          <template v-slot:append-outer>
            <div v-if="errors.length > 0">
              <v-tooltip top color="#ff5252">
                <template v-slot:activator="{ on }">
                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                </template>
                
                Jabatan Yang Bertandatangan {{ errors[0] }}
              </v-tooltip>
            </div>

            <div v-if="form.template_meta_json_object.jabatan_1 !== '' && valid">
              <v-icon color="success">mdi-check-circle-outline</v-icon>
            </div>
          </template>
        </v-text-field>
      </ValidationProvider>

      <ValidationProvider 
        name="Nama Penerima" 
        rules="required" 
        v-slot="{ errors, valid }">
        <div class="body-2 mb-2">
          <span class="red--text">*</span>
          Nama Penerima
          <span class="error--text">
            (wajib diisi)
          </span>
        </div>
        
        <v-text-field
          filled
          rounded
          dense
          :color="set_color"
          
          placeholder="Contoh. Nama Penerima."
          hide-details

          v-model="form.template_meta_json_object.nama_penerima"
          :success="valid"
          :error-messages="errors"
          required
          class="mb-6"
          style="border-radius: 10px;">
          <template v-slot:append-outer>
            <div v-if="errors.length > 0">
              <v-tooltip top color="#ff5252">
                <template v-slot:activator="{ on }">
                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                </template>
                
                Nama Penerima {{ errors[0] }}
              </v-tooltip>
            </div>

            <div v-if="form.template_meta_json_object.nama_penerima !== '' && valid">
              <v-icon color="success">mdi-check-circle-outline</v-icon>
            </div>
          </template>
        </v-text-field>
      </ValidationProvider>

      <ValidationProvider 
        name="Tempat Lahir" 
        rules="required" 
        v-slot="{ errors, valid }">
        <div class="body-2 mb-2">
          <span class="red--text">*</span>
          Tempat Lahir
          <span class="error--text">
            (wajib diisi)
          </span>
        </div>
        
        <v-text-field
          filled
          rounded
          dense
          :color="set_color"
          
          placeholder="Contoh. Tempat Lahir"
          hide-details

          v-model="form.template_meta_json_object.tempat_lahir"
          :success="valid"
          :error-messages="errors"
          required
          class="mb-6"
          style="border-radius: 10px;">
          <template v-slot:append-outer>
            <div v-if="errors.length > 0">
              <v-tooltip top color="#ff5252">
                <template v-slot:activator="{ on }">
                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                </template>
                
                Tempat Lahir {{ errors[0] }}
              </v-tooltip>
            </div>

            <div v-if="form.template_meta_json_object.tempat_lahir !== '' && valid">
              <v-icon color="success">mdi-check-circle-outline</v-icon>
            </div>
          </template>
        </v-text-field>
      </ValidationProvider>

      <div>
        <div class="body-2 mb-2">
          <span class="red--text">*</span>
          Tanggal Lahir
          <span class="error--text">
            (wajib diisi)
          </span>
        </div>

        <v-menu
          ref="tanggal"
          min-width="290px"
          max-width="290px"
          transition="scale-transition"
          offset-y
          :nudge-right="40"
          :close-on-content-click="false"
          v-model="picker.tanggal_lahir">
          <template v-slot:activator="{ on, attrs }">
            <ValidationProvider 
              name="Tanggal Lahir" 
              rules="required"
              v-slot="{ errors, valid }">
              <v-text-field
                readonly
                filled
                rounded
                dense
                :color="set_color"
                placeholder="Pilih Tanggal"
                hide-details
                clearable

                @click:clear="form.template_meta_json_object.tanggal_lahir = null;"
                v-on="on"
                v-bind="attrs"

                v-model="form.template_meta_json_object.tanggal_lahir"
                :success="form.template_meta_json_object.tanggal_lahir !== null && valid"
                :error-messages="errors"
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Tanggal Lahir {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.template_meta_json_object.tanggal_lahir !== null && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
          </template>

          <v-date-picker 
            :color="set_color"
            v-model="form.template_meta_json_object.tanggal_lahir"
            @input="picker.tanggal_lahir = false">
          </v-date-picker>
        </v-menu>
      </div>

      <ValidationProvider 
        name="Alamat" 
        rules="required" 
        v-slot="{ errors, valid }">
        <div class="body-2 mb-2">
          <span class="red--text">*</span>
          Alamat
          <span class="error--text">
            (wajib diisi)
          </span>
        </div>
        
        <v-text-field
          filled
          rounded
          dense
          :color="set_color"
          
          placeholder="Contoh. alamat"
          hide-details

          v-model="form.template_meta_json_object.alamat"
          :success="valid"
          :error-messages="errors"
          required
          class="mb-6"
          style="border-radius: 10px;">
          <template v-slot:append-outer>
            <div v-if="errors.length > 0">
              <v-tooltip top color="#ff5252">
                <template v-slot:activator="{ on }">
                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                </template>
                
                Alamat {{ errors[0] }}
              </v-tooltip>
            </div>

            <div v-if="form.template_meta_json_object.alamat !== '' && valid">
              <v-icon color="success">mdi-check-circle-outline</v-icon>
            </div>
          </template>
        </v-text-field>
      </ValidationProvider>

      <ValidationProvider 
        name="Nomor KTP" 
        rules="required" 
        v-slot="{ errors, valid }">
        <div class="body-2 mb-2">
          <span class="red--text">*</span>
          Nomor KTP
          <span class="error--text">
            (wajib diisi)
          </span>
        </div>
        
        <v-text-field
          filled
          rounded
          dense
          :color="set_color"
          
          placeholder="Contoh. Ktp"
          hide-details
          type="number"

          v-model="form.template_meta_json_object.ktp"
          :success="valid"
          :error-messages="errors"
          required
          class="mb-6"
          style="border-radius: 10px;">
          <template v-slot:append-outer>
            <div v-if="errors.length > 0">
              <v-tooltip top color="#ff5252">
                <template v-slot:activator="{ on }">
                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                </template>
                
                Nomor KTP {{ errors[0] }}
              </v-tooltip>
            </div>

            <div v-if="form.template_meta_json_object.ktp !== '' && valid">
              <v-icon color="success">mdi-check-circle-outline</v-icon>
            </div>
          </template>
        </v-text-field>
      </ValidationProvider>

      <ValidationProvider
        name="Unit" 
        rules="required" 
        v-slot="{ errors, valid }">
        <div class="body-2 mb-2">
          <span class="red--text">*</span>
          Unit
          <span class="error--text">
            (wajib diisi)
          </span>
        </div>

        <v-autocomplete
          filled
          rounded
          dense
          :color="set_color"
          hide-details
          placeholder="Contoh. UMB Boga"

          :loading="process.unit"
          
          :items="units"
          item-value="name"
          item-text="name"
          :item-color="set_color"

          v-model="form.template_meta_json_object.bekerja"
          :success="form.template_meta_json_object.bekerja !== '' && valid"
          :error-messages="errors"
          required
          class="mb-6"
          style="border-radius: 10px;">
          <template v-slot:append-outer>
            <div v-if="errors.length > 0">
              <v-tooltip top color="#ff5252">
                <template v-slot:activator="{ on }">
                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                </template>
                
                Unit {{ errors[0] }}
              </v-tooltip>
            </div>

            <div v-if="form.template_meta_json_object.bekerja !== '' && valid">
              <v-icon color="success">mdi-check-circle-outline</v-icon>
            </div>
          </template>
        </v-autocomplete>
      </ValidationProvider>

      <v-row>
        <v-col
          cols="12"
          md="5"
          class="py-0">
          <div>
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Tanggal Mulai
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>

            <v-menu
              ref="tanggal_mulai"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.tanggal_mulai">
              <template v-slot:activator="{ on, attrs }">
                <ValidationProvider 
                  name="Tanggal Mulai" 
                  rules="required"
                  v-slot="{ errors, valid }">
                  <v-text-field
                    readonly
                    filled
                    rounded
                    dense
                    :color="set_color"
                    placeholder="Pilih Tanggal"
                    hide-details
                    clearable

                    @click:clear="form.template_meta_json_object.tanggal_mulai = null; form.template_meta_json_object.tanggal_selesai = null;"
                    v-on="on"
                    v-bind="attrs"

                    v-model="form.template_meta_json_object.tanggal_mulai"
                    :success="form.template_meta_json_object.tanggal_mulai !== null && valid"
                    :error-messages="errors"
                    class="mb-6"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Tanggal Mulai {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.template_meta_json_object.tanggal_mulai !== null && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </template>

              <v-date-picker 
                :color="set_color"
                v-model="form.template_meta_json_object.tanggal_mulai"
                @input="picker.tanggal_mulai = false; form.template_meta_json_object.tanggal_selesai = null;">
              </v-date-picker>
            </v-menu>
          </div>
        </v-col>

        <v-col
          cols="12"
          md="5"
          class="py-0">
          <div>
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Tanggal Selesai
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>

            <v-menu
              ref="tanggal_selesai"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.tanggal_selesai">
              <template v-slot:activator="{ on, attrs }">
                <ValidationProvider 
                  name="Tanggal Selesai" 
                  rules="required"
                  v-slot="{ errors, valid }">
                  <v-text-field
                    readonly
                    filled
                    rounded
                    dense
                    :color="set_color"
                    placeholder="Pilih Tanggal"
                    hide-details
                    clearable

                    @click:clear="form.template_meta_json_object.tanggal_selesai = null;"
                    v-on="on"
                    v-bind="attrs"

                    v-model="form.template_meta_json_object.tanggal_selesai"
                    :success="form.template_meta_json_object.tanggal_selesai !== null && valid"
                    :error-messages="errors"
                    class="mb-6"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Tanggal Selesai {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.template_meta_json_object.tanggal_selesai !== null && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </template>

              <v-date-picker 
                :color="set_color"
                :min="form.template_meta_json_object.tanggal_mulai"
                v-model="form.template_meta_json_object.tanggal_selesai"
                @input="picker.tanggal_selesai = false">
              </v-date-picker>
            </v-menu>
          </div>
        </v-col>
      </v-row>

      <ValidationProvider 
        name="Jabatan Terakhir" 
        rules="required" 
        v-slot="{ errors, valid }">
        <div class="body-2 mb-2">
          <span class="red--text">*</span>
          Jabatan Terakhir
          <span class="error--text">
            (wajib diisi)
          </span>
        </div>
        
        <v-text-field
          filled
          rounded
          dense
          :color="set_color"
          
          placeholder="Contoh. jabatan"
          hide-details

          v-model="form.template_meta_json_object.jabatan"
          :success="valid"
          :error-messages="errors"
          required
          class="mb-6"
          style="border-radius: 10px;">
          <template v-slot:append-outer>
            <div v-if="errors.length > 0">
              <v-tooltip top color="#ff5252">
                <template v-slot:activator="{ on }">
                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                </template>
                
                Jabatan Terakhir {{ errors[0] }}
              </v-tooltip>
            </div>

            <div v-if="form.template_meta_json_object.jabatan !== '' && valid">
              <v-icon color="success">mdi-check-circle-outline</v-icon>
            </div>
          </template>
        </v-text-field>
      </ValidationProvider>

      <div>
        <div class="body-2 mb-2">
          <span class="red--text">*</span>
          Tanggal
          <span class="error--text">
            (wajib diisi)
          </span>
        </div>

        <v-menu
          ref="tanggal"
          min-width="290px"
          max-width="290px"
          transition="scale-transition"
          offset-y
          :nudge-right="40"
          :close-on-content-click="false"
          v-model="picker.tanggal">
          <template v-slot:activator="{ on, attrs }">
            <ValidationProvider 
              name="Tanggal" 
              rules="required"
              v-slot="{ errors, valid }">
              <v-text-field
                readonly
                filled
                rounded
                dense
                :color="set_color"
                placeholder="Pilih Tanggal"
                hide-details
                clearable

                @click:clear="form.template_meta_json_object.tanggal = null;"
                v-on="on"
                v-bind="attrs"

                v-model="form.template_meta_json_object.tanggal"
                :success="form.template_meta_json_object.tanggal !== null && valid"
                :error-messages="errors"
                class="mb-6"
                style="border-radius: 10px; width: 40%;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Tanggal {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
          </template>

          <v-date-picker 
            :color="set_color"
            v-model="form.template_meta_json_object.tanggal"
            @input="picker.tanggal = false">
          </v-date-picker>
        </v-menu>
      </div>

    </v-col>

      <v-col
        cols="12"
        md="6">
        <v-card
          flat
          style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
          <div
            ref="arsippdf"
            style="padding: 50px;">
            <v-card-text
              class="black--text py-2">
              <div class="text-center body-1 font-weight-bold mb-5">
                Surat Keterangan Kerja
              </div>
              <v-row>
                <v-col
                  cols="12"
                  md="7">
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Nomor
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.nomor !== '' ? form.template_meta_json_object.nomor : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Lam
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.lampiran !== '' ? form.template_meta_json_object.lampiran : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Perihal
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0 d-flex align-start"
                      style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; align-items: flex-start !important;">
                      : <span class="ml-1" style="font-weight: 500; margin-left: 4px !important;">{{ form.template_meta_json_object.hal !== '' ? form.template_meta_json_object.hal : '__________' }}</span>
                    </v-col>
                  </v-row>
                </v-col>

                <!-- <v-col
                  cols="12"
                  md="5">
                  <div
                    class="text-right"
                    style="text-align: right !important;">
                    Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                  </div>
                </v-col> -->
              </v-row>

              <div
                class="mt-4"
                style="margin-top: 9px !important;">
                <v-img
                  contain
                  width="175"
                  height="auto"
                  alt="umb" 
                  :src="require('@/assets/image/assalam.jpeg')">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>

                <div
                  class="my-4"
                  style="margin-top: 16px !important; margin-bottom: 16px !important;">
                  <div
                    class="mb-4"
                    style="margin-bottom: 16px !important;">
                    Yang bertanda tangan di bawah ini:
                  </div>

                  <div
                    class="mb-4"
                    style="margin-bottom: 16px !important;">
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Nama
                      </v-col>

                      <v-col
                        cols="12"
                        md="9"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Jabatan
                      </v-col>

                      <v-col
                        cols="12"
                        md="9"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                      </v-col>
                    </v-row>
                  </div>

                  <div
                    class="mb-4"
                    style="margin-bottom: 16px !important;">
                    Dengan ini menerangkan bahwa:
                  </div>

                  <div
                    class="mb-4"
                    style="margin-bottom: 16px !important;">
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Nama
                      </v-col>

                      <v-col
                        cols="12"
                        md="9"
                        class="py-0 d-flex align-start"
                        style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; lign-items: flex-start !important;">
                        : 
                        <span
                          class="ml-1"
                          style="margin-left: 4px !important;">
                          {{ form.template_meta_json_object.nama_penerima !== '' ? form.template_meta_json_object.nama_penerima : '__________' }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Tempat/Tanggal Lahir
                      </v-col>

                      <v-col
                        cols="12"
                        md="9"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : 
                        {{ form.template_meta_json_object.tempat_lahir !== '' ? form.template_meta_json_object.tempat_lahir : '__________' }}
                        
                        /

                        <span v-if="form.template_meta_json_object.tanggal_lahir !== '' && form.template_meta_json_object.tanggal_lahir !== null">
                          {{ form.template_meta_json_object.tanggal_lahir | fulldate }}
                        </span>

                        <span v-else>
                          __________
                        </span>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Alamat
                      </v-col>

                      <v-col
                        cols="12"
                        md="9"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.alamat !== '' ? form.template_meta_json_object.alamat : '__________' }}
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Nomor KTP
                      </v-col>

                      <v-col
                        cols="12"
                        md="9"
                        class="py-0 d-flex align-start"
                        style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; lign-items: flex-start !important;">
                        : 
                        <span
                          class="ml-1"
                          style="margin-left: 4px !important;">
                          {{ form.template_meta_json_object.ktp !== '' ? form.template_meta_json_object.ktp : '__________' }}
                        </span>
                      </v-col>
                    </v-row>
                  </div>

                  <div
                    style="">
                    Adalah benar karyawan kami yang bekerja di {{ form.template_meta_json_object.bekerja !== '' ? form.template_meta_json_object.bekerja : '__________' }} sejak tanggal <span v-if="form.template_meta_json_object.tanggal_mulai !== '' && form.template_meta_json_object.tanggal_mulai !== null">
                      {{ form.template_meta_json_object.tanggal_mulai | fulldate }} 
                    </span>

                    <span v-else>
                      __________
                    </span>
                    sampai dengan
                    <span v-if="form.template_meta_json_object.tanggal_selesai !== '' && form.template_meta_json_object.tanggal_selesai !== null">
                      {{ form.template_meta_json_object.tanggal_selesai | fulldate }} 
                    </span>

                    <span v-else>
                      __________
                    </span> dengan jabatan terakhir sebagai {{ form.template_meta_json_object.jabatan !== '' ? form.template_meta_json_object.jabatan : '__________' }} Selama bekerja di perusahaan kami, yang bersangkutan telah menunjukkan dedikasi dan kinerja yang baik serta berkontribusi positif terhadap perusahaan.
                  </div>
                </div>

                <v-img
                  contain
                  width="175"
                  height="auto"
                  alt="umb" 
                  :src="require('@/assets/image/wassalam.jpeg')">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>

              <v-row
                justify="end"
                class="mt-8"
                style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                <v-col
                  cols="12"
                  md="6"
                  class="text-center"
                  style="text-align: right !important;">
                  <div>
                    Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                  </div>

                  <div
                    class="mb-16"
                    style="margin-bottom: 64px !important;">
                    {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                  </div>

                  <div>
                    {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import html2pdf from 'html2pdf.js'
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      },
      units: {
        type: Array,
        default: []
      },
      process: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        picker: {
          expired: false,
          tanggal: false,
          tanggal_mulai: false,
          tanggal_selesai: false,
          tanggal_masuk: false,
          tanggal_lahir: false,

          range: false
        },

        time: {
          pukul: false
        },
      }
    },
    components: {
      
    },
    watch: {

    },
    computed: {
      user () {
        return this.$store.state.user
      },
      
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      // formattedDate: {
      //   get () {
      //     return (this.form.template_meta_json_object.tanggal && this.form.template_meta_json_object.tanggal.length === 10) ? moment(this.form.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.form.template_meta_json_object.tanggal
      //   },
      //   set (newValue) {
      //     if (newValue && newValue.length == 10) {
      //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
      //         this.form.template_meta_json_object.tanggal = newDate
      //     }
      //   }
      // },

      date_range () {
        return this.filter.dates.join(' s/d ')
      }
    },
    mounted () {
      
    },
    methods: {
      add_pegawai () {
        this.form.template_meta_json_object.kepada.push({
          nama: '',
          unit: ''
        })
      },
    }
  }
</script>
